import React from 'react'
import { AUTH_PREFIX_PATH, APP_PREFIX_PATH } from 'configs/AppConfig'

export const publicRoutes = [
    {
        key: 'login',
        path: `${AUTH_PREFIX_PATH}/login`,
        component: React.lazy(() => import('views/auth-views/authentication/login')),
    }
]

export const protectedRoutes = [
    {
        key: 'dashboard.default',
        path: `${APP_PREFIX_PATH}/dashboards/default`,
        component: React.lazy(() => import('views/app-views/dashboards/default')),
    },
    
    {
        key: 'userdetails.usertable',
        path: `${APP_PREFIX_PATH}/userdetails/usertable`,
        component: React.lazy(() => import('views/app-views/userdetails/usertable')),
    },
    {
        key: 'userdetails.adduser',
        path: `${APP_PREFIX_PATH}/userdetails/adduser`,
        component: React.lazy(() => import('views/app-views/userdetails/adduser')),
    },
    {
        key: 'userdetails.userposttable',
        path: `${APP_PREFIX_PATH}/userdetails/userposttable`,
        component: React.lazy(() => import('views/app-views/userdetails/userposttable')),
    },
    {
        key: 'userdetails.account_band',
        path: `${APP_PREFIX_PATH}/userdetails/account_band`,
        component: React.lazy(() => import('views/app-views/userdetails/account_band')),
    },
    {
        key: 'userdetails.account_delete',
        path: `${APP_PREFIX_PATH}/userdetails/account_delete`,
        component: React.lazy(() => import('views/app-views/userdetails/account_delete')),
    },


    
    {
        key: 'userdetails.report_sentence',
        path: `${APP_PREFIX_PATH}/userdetails/report_sentence`,
        component: React.lazy(() => import('views/app-views/userdetails/report_sentence')),
    },
    {
        key: 'lands.landtype',
        path: `${APP_PREFIX_PATH}/lands/landtypes`,
        component: React.lazy(() => import('views/app-views/lands/landtypes')),
    },
    {
        key: 'lands.landcategoies',
        path: `${APP_PREFIX_PATH}/lands/landcategoies`,
        component: React.lazy(() => import('views/app-views/lands/landcategoies')),
    },
    {
        key: 'lands.floor_plane',
        path: `${APP_PREFIX_PATH}/landforms/floor_plane`,
        component: React.lazy(() => import('views/app-views/landforms/floor_plane')),
    },
    {
        key: 'lands.property_facing',
        path: `${APP_PREFIX_PATH}/landforms/property_facing`,
        component: React.lazy(() => import('views/app-views/landforms/property_facing')),
    }, 
    {
        key: 'lands.property_ownership',
        path: `${APP_PREFIX_PATH}/landforms/property_ownership`,
        component: React.lazy(() => import('views/app-views/landforms/property_ownership')),
    },
    {
        key: 'lands.availability_status',
        path: `${APP_PREFIX_PATH}/landforms/availability_status`,
        component: React.lazy(() => import('views/app-views/landforms/availability_status')),
    },
    {
        key: 'lands.other_rooms',
        path: `${APP_PREFIX_PATH}/landforms/other_rooms`,
        component: React.lazy(() => import('views/app-views/landforms/other_rooms')),
    },
    {
        key: 'lands.furnishing_status',
        path: `${APP_PREFIX_PATH}/landforms/furnishing_status`,
        component: React.lazy(() => import('views/app-views/landforms/furnishing_status')),
    },
    {
        key: 'lands.amenities',
        path: `${APP_PREFIX_PATH}/landforms/amenities`,
        component: React.lazy(() => import('views/app-views/landforms/amenities')),
    },
    {
        key: 'lands.property_highlights',
        path: `${APP_PREFIX_PATH}/landforms/property_highlights`,
        component: React.lazy(() => import('views/app-views/landforms/property_highlights')),
    },
    {
        key: 'lands.reception_area',
        path: `${APP_PREFIX_PATH}/landforms/reception_area`,
        component: React.lazy(() => import('views/app-views/landforms/reception_area')),
    },
    {
        key: 'lands.oxygen_duct',
        path: `${APP_PREFIX_PATH}/landforms/oxygen_duct`,
        component: React.lazy(() => import('views/app-views/landforms/oxygen_duct')),
    },
    {
        key: 'lands.ups',
        path: `${APP_PREFIX_PATH}/landforms/ups`,
        component: React.lazy(() => import('views/app-views/landforms/ups')),
    },
    {
        key: 'lands.lifts',
        path: `${APP_PREFIX_PATH}/landforms/lifts`,
        component: React.lazy(() => import('views/app-views/landforms/lifts')),
    },
    {
        key: 'lands.office_previously_used_for',
        path: `${APP_PREFIX_PATH}/landforms/office_previously_used_for`,
        component: React.lazy(() => import('views/app-views/landforms/office_previously_used_for')),
    },
    {
        key: 'lands.fire_safety_measures',
        path: `${APP_PREFIX_PATH}/landforms/fire_safety_measures`,
        component: React.lazy(() => import('views/app-views/landforms/fire_safety_measures')),
    },
    {
        key: 'lands.washroom_details',
        path: `${APP_PREFIX_PATH}/landforms/washroom_details`,
        component: React.lazy(() => import('views/app-views/landforms/washroom_details')),
    },
    {
        key: 'lands.suitable_business_type',
        path: `${APP_PREFIX_PATH}/landforms/suitable_business_type`,
        component: React.lazy(() => import('views/app-views/landforms/suitable_business_type')),
    },
    




    
    {
        key: 'enquire.enquire_table',
        path: `${APP_PREFIX_PATH}/enquire/enquire_table`,
        component: React.lazy(() => import('views/app-views/userdetails/enquire/enquire_table')),
    },
    {
        key: 'enquire.enquire_table',
        path: `${APP_PREFIX_PATH}/enquire/add_enquire`,
        component: React.lazy(() => import('views/app-views/userdetails/enquire/add_enquire')),
    },
    {
        key: 'enquire.enquire_decline',
        path: `${APP_PREFIX_PATH}/enquire/enquire_decline`,
        component: React.lazy(() => import('views/app-views/userdetails/enquire/enquire_decline')),
    },




    {
        key: 'book_visit.book_visit_list',
        path: `${APP_PREFIX_PATH}/book_visit/book_visit_list`,
        component: React.lazy(() => import('views/app-views/userdetails/book_visit/book_visit_list')),
    },




    {
        key: 'subcription.subcription_plan_list',
        path: `${APP_PREFIX_PATH}/subcription/subcription_plan_list`,
        component: React.lazy(() => import('views/app-views/subcription/subcription_plan_list')),
    },
    {
        key: 'subcription.product',
        path: `${APP_PREFIX_PATH}/subcription/product`,
        component: React.lazy(() => import('views/app-views/subcription/product')),
    },
    {
        key: 'subcription.subcription_plan_category',
        path: `${APP_PREFIX_PATH}/subcription/subcription_plan_category`,
        component: React.lazy(() => import('views/app-views/subcription/subcription_plan_category')),
    },
    {
        key: 'subcription.benefits',
        path: `${APP_PREFIX_PATH}/subcription/benefits`,
        component: React.lazy(() => import('views/app-views/subcription/benefits')),
    },
    

    

]